export default {"src":"/_next/static/media/Alarm.e0279b44.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};